import React, { useState } from 'react'
import Swal from 'sweetalert2'
import api from '../../API/api';
import axios from 'axios';



function AddHiring(props) {

    // console.log("modalData", props.modalData);


    const [data, setData] = useState({
        name: '',
        email: '',
        number: '',
    })
    const [file, setFile] = useState();


    function handleInput(e) {
        setData({
            ...data,
            [e.target.name]: e.target.value
        })
    }

    function handleInputFile(e) {
        setFile(e.target.files[0])
    }

    function handleSubmit() {
        // console.log(file, data,props.modalData?.id, 'check careere');
        if (data.name?.trim().length <= 0 || data.name === undefined) {
            props.handleClose();
            Swal.fire({
                title: 'Error!',
                text: 'Name cannot be blank',
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            return ;
        }
        if (file === undefined) {
            props.handleClose();
            Swal.fire({
                title: 'Error!',
                text: 'CV  cannot be blank',
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            return ;
        }
        const postData = new FormData();
        postData.append('name', data.name)             
        postData.append('number', data.number)             
        postData.append('email', data.email)             
        postData.append('resume', file)             
        postData.append('job_id' , props.modalData?.id)
        postData.append('official_mail' , props.modalData?.official_mail)

        // return props.modalData?.id;
        axios.post(`${process.env.REACT_APP_MAIN_API}resumeUpload`, postData)
        .then(res => {
            // console.log(res, 'check creer res');
            props.handleClose();
            if (res.data.status === 200) {
                Swal.fire({
                    title: 'Success',
                    text: 'Applied Successfully',
                    icon: 'success',
                    confirmButtonText: 'Ok'
                })
            }
        }).catch(err => {
            // console.log(err, 'check creer res');
        })

    }

    return (
        <>
        <h4>Apply for Post</h4>
            <div className='row'>
                <div className='col-md-6 p-2'>
                    <label htmlFor="">Name:</label>
                    <input type="text" className='form-control' name="name" onChange={handleInput} />
                </div>

                <div className='col-md-6 p-2'>
                    <label htmlFor="">Email:</label>
                    <input type="email" className='form-control' name="email" onChange={handleInput} />
                </div>
                <div className='col-md-6 p-2'>
                    <label htmlFor="">Phone:</label>
                    <input type="number" maxLength={10} className='form-control' name="number" onChange={handleInput} />
                </div>
                <div className='col-md-6 p-2'>
                    <label htmlFor="">Upload CV:</label>
                    <input type="file" className='form-control'  accept=".doc.docx,.pdf" name="file" onChange={handleInputFile} />
                </div>
                <div className='text-center pt-4 pb-0'>
                    <button className='btn btn-primary btn-sm' onClick={handleSubmit}> Submit </button>
                </div>
            </div>

        </>
    )
}

export default AddHiring;